export const ButtonStyle = {
    baseStyles: {},
    variants: {
        primary: {
            bgGradient: "linear(to-r, #0095C8, #016293)",
            color: "white",
            px: "60px",
            fontWeight: "600",
            borderRadius: "6px",
            _hover: {
                bgGradient: "linear(to-r, #016293, #0095C8)",
                transitionDuration: "0.3s",
                transitionTimingFunction: "ease-in-out",
            }
        },
        large: {
            bgGradient: "linear(to-r, #0095C8, #016293)",
            color: "white",
            px: { base: "40px", md: "60px" },
            py: { base: "20px", md: "25px" },
            fontWeight: "600",
            fontSize: { base: "1rem", md: "1.1rem" },
            borderRadius: "6px",
            _hover: {
                bgGradient: "linear(to-r, #016293, #0095C8)",
                transitionDuration: "0.3s",
                transitionTimingFunction: "ease-in-out",
            }
        },
        secondary: {
            bg: "white",
            color: "primary",
            px: "40px",
            fontWeight: "600",
            borderRadius: "6px",
            border: "2px solid",
            borderColor: "#0095C8",
            _hover: {
                bg: "#E9FFFF",
                transitionDuration: "0.3s",
                transitionTimingFunction: "ease-in-out",
            }
        },
        outline: {
            bg: "transparent",
            color: "white",
            px: { base: "40px", md: "60px" },
            py: { base: "20px", md: "25px" },
            fontWeight: "600",
            fontSize: { base: "1rem", md: "1.1rem" },
            borderRadius: "6px",
            border: "2px solid white",
            _hover: {
                bg: "rgba(255,255,255,0.1)",
                transitionDuration: "0.3s",
            }
        }
    },
    sizes: {},
    defaultProps: {},
}
